import { PermissionEnum } from '~/roles/types';
import { FeaturesEnum } from '~/features/types';

export default [
  {
    path: '/monitoring-user/:id?',
    meta: {
      auth: true,
      permissions: [PermissionEnum.USER_MONITORING],
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'trackingUser',
        component: () => import('~/dashboard/pages/TrackingUserDashboard.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
    ],
  },
  {
    path: '/monitoring-details',
    meta: {
      auth: true,
      permissions: [PermissionEnum.WORKER_MONITORING],
      feature: FeaturesEnum.DASHBOARDS,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'trackingDetails',
        component: () => import('~/dashboard/pages/TrackingDetails.vue'),
      },
    ],
  },
];
